import React, { useState, createContext, useContext, useEffect } from "react";

import { Box } from "@mui/material";

import { ProSidebarProvider } from "react-pro-sidebar";

import MyProSidebar from "./MyProSidebar";
import Footer from "./Footer";
import LeftNavBar from "./LeftNavBar";

const SidebarContext = createContext({});

export const MyProSidebarProvider = ({ children }) => {
  const [sidebarRTL, setSidebarRTL] = useState(false);

  const [sidebarBackgroundColor, setSidebarBackgroundColor] =
    useState(undefined);

  const [sidebarImage, setSidebarImage] = useState(undefined);

  const [sidebarOpen, setSidebarOpen] = useState(true);

  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  /* =========================================================
     SIDEBAR TOGGLE
  ========================================================= */

  const toggleSidebar = () => {
    setSidebarOpen((previous) => !previous);
  };

  /* =========================================================
     WINDOW HEIGHT
  ========================================================= */

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  /* =========================================================
     LAYOUT
  ========================================================= */

  return (
    <ProSidebarProvider>
      <SidebarContext.Provider
        value={{
          sidebarBackgroundColor,
          setSidebarBackgroundColor,

          sidebarImage,
          setSidebarImage,

          sidebarRTL,
          setSidebarRTL,

          sidebarOpen,
          setSidebarOpen,

          toggleSidebar,
        }}
      >
        <Box
          sx={{
            display: "flex",

            flexDirection: sidebarRTL ? "row-reverse" : "row",

            height: `${windowHeight}px`,

            width: "100%",

            backgroundColor: "#F5F7FA",

            overflow: "hidden",
          }}
        >
          {/* =================================================
              SIDEBAR
          ================================================= */}

         <MyProSidebar sidebarOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

          {/* =================================================
              MAIN AREA
          ================================================= */}

          <Box
            sx={{
              flex: 1,

              minWidth: 0,

              minHeight: 0,

              display: "flex",

              flexDirection: "column",
            }}
          >
            {/* =================================================
                HEADER
            ================================================= */}

            <LeftNavBar
              sidebarOpen={sidebarOpen}
              toggleSidebar={toggleSidebar}
            />

            {/* =================================================
                CONTENT + FOOTER
            ================================================= */}

            <Box
              sx={{
                flex: 1,

                minWidth: 0,

                minHeight: 0,

                overflowY: "auto",

                display: "flex",

                flexDirection: "column",

                backgroundColor: "#F5F7FA",
              }}
            >
              {/* =================================================
                  PAGE CONTENT
              ================================================= */}

              {children}

              {/* =================================================
                  FOOTER
              ================================================= */}

              <Box
                sx={{
                  mt: "auto",
                  flexShrink: 0,
                }}
              >
                <Footer />
              </Box>
            </Box>
          </Box>
        </Box>
      </SidebarContext.Provider>
    </ProSidebarProvider>
  );
};

export const useSidebarContext = () => useContext(SidebarContext);
